<template>
    <svg
        class="kknext"
        width="14px"
        height="33px"
        viewBox="0 0 14 33"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
    >
        <!-- Generator: Sketch 57.1 (83088) - https://sketch.com -->
        <defs>
            <polygon
                id="path-1"
                points="0 0.0004 16.799 0.0004 16.799 48.6904 0 48.6904"
            ></polygon>
        </defs>
        <g
            id="Component"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
        >
            <g
                id="Component-Guideline"
                transform="translate(-177.000000, -2545.000000)"
            >
                <g
                    id="arrow_normal"
                    transform="translate(160.000000, 2521.000000)"
                >
                    <g id="Group-3" transform="translate(17.000000, 16.000000)">
                        <mask id="mask-2" fill="white">
                            <use xlink:href="#path-1"></use>
                        </mask>
                        <g id="Clip-2"></g>
                        <path
                            d="M12.0029,20.0024 L-8.0001,0.0004 L-8.0001,2.8284 L-8.0001,5.6564 L9.1749,22.8304 C10.0099,23.6664 10.0099,25.0244 9.1749,25.8604 L-8.0001,43.0344 L-8.0001,45.8624 L-8.0001,48.6904 L12.0029,28.6884 C14.3979,26.2944 14.3979,22.3974 12.0029,20.0024"
                            id="kk-next-arrow"
                            :fill="color"
                            mask="url(#mask-2)"
                        ></path>
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'kkNext',
    props: {
        color: {
            type: String,
            default: '#7B7B7B',
        },
    },
};
</script>
